// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__EoJ-G","label":"Labeled_label__3NJst","divider":"Labeled_divider__2xLw3"};